<script setup>
defineProps({
  intro: {
    type: Object,
    default: () => ({}),
  },
})
</script>

<template>
  <div class="intro-pagine">
    <div class="row-400-20 p-bot-1 max">
      <div class="main-section">
        <!-- eslint-disable vue/no-v-html -->
        <h1
          v-if="intro.titolo"
          class="heading-1 intro-page"
          v-html="intro.titolo"
        />
        <div class="flex-intro m-top-3 text-2">
          <div v-if="intro.testoSinistra" class="left">
            <!-- eslint-disable vue/no-v-html -->
            <div v-html="intro.testoSinistra" />
          </div>
          <div v-if="intro.testoDestra" class="right">
            <!-- eslint-disable vue/no-v-html -->
            <div v-html="intro.testoDestra" />
          </div>
        </div>
        <div
          v-if="$route.path === '/questionario-conformita'"
          class="questionario-btn"
        >
          <button class="form-contact__submit">
            <a
              href="https://r6ud1zrt7vg.typeform.com/to/FrrQBXv9"
              target="_blank"
              >Vai al questionario</a
            >
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IntroPagine',
}
</script>

<style lang="scss">
@import './style.scss';
</style>
